module.exports = __webpack_public_path__ + "e5e911c9943f5b91bcb94f379ffd2dd5.svg";